import React from "react";
import TransformToolPrep from "../../shared/Popup/TransformToolPrep";

const FlipToolPrep = (props) => (
  <TransformToolPrep mode="flip" {...props} />
);

export default FlipToolPrep;
